import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getWorkplaces = store => store[NAME].workplaces;
export const getTurns = store => store[NAME].turns;
export const getEmployees = store => store[NAME].employees;
export const getShifts = store => store[NAME].shifts;
export const getSchedules = store => store[NAME].schedules;
export const getOpenCalendars = store => store[NAME].openCalendars;
